import AboutLayout from './about_layout';

export default AboutLayout;
